<main class="flex" id="editor-page">
  <app-new-sidebar></app-new-sidebar>
  <div
    class="h-screen expanded-results-section-whitespace"
    id="editor"
    [ngClass]="{
      'w-screen': resultsCollapsed,
    }"
  >
    <div class="flex flex-col h-screen">
      <div class="container flex justify-between items-center pt-4">
        <div class="border-none" #editorToolbar>
          <span class="has-tooltip">
            <button class="ql-bold" (click)="editorEnabled = true"></button>
            <span class="tooltip-content tooltip-bottom">Bold</span>
          </span>
          <span class="has-tooltip">
            <button class="ql-italic" (click)="editorEnabled = true"></button>
            <span class="tooltip-content tooltip-bottom">Italic</span>
          </span>
          <span class="has-tooltip">
            <button
              class="ql-underline"
              (click)="editorEnabled = true"
            ></button>
            <span class="tooltip-content tooltip-bottom">Underline</span>
          </span>
          <span class="has-tooltip">
            <button class="ql-header" value="1"></button>
            <span class="tooltip-content tooltip-bottom">Heading Level 1</span>
          </span>
          <span class="has-tooltip">
            <button class="ql-header" value="2"></button>
            <span class="tooltip-content tooltip-bottom">Heading Level 2</span>
          </span>
          <span class="has-tooltip">
            <button class="ql-align" value=""></button>
            <span class="tooltip-content tooltip-bottom">Align Left</span>
          </span>
          <span class="has-tooltip">
            <button class="ql-align" value="center"></button>
            <span class="tooltip-content tooltip-bottom">Align Center</span>
          </span>
          <span class="has-tooltip">
            <button class="ql-align" value="right"></button>
            <span class="tooltip-content tooltip-bottom">Align Right</span>
          </span>
          <span class="has-tooltip">
            <button class="ql-align" value="justify"></button>
            <span class="tooltip-content tooltip-bottom">Align Justify</span>
          </span>
          <span class="has-tooltip">
            <button class="ql-list" value="bullet"></button>
            <span class="tooltip-content tooltip-bottom">Unordered List</span>
          </span>
          <span class="has-tooltip">
            <button class="ql-list" value="ordered"></button>
            <span class="tooltip-content tooltip-bottom">Ordered List</span>
          </span>
          <span class="has-tooltip">
            <button class="ql-blockquote"></button>
            <span class="tooltip-content tooltip-bottom">Blockquote</span>
          </span>
        </div>

        <div
          style="
            position: relative;
            position: relative;
            border: 1px solid #f1f2f7;
            background: transparent;
            border-radius: 0.375rem;
            color: inherit;
            padding: 1px 7px 4px 10px;
          "
          class="grid items-center switch-language-dropdown-container"
        >
          <button
            (click)="toggleReportMenu($event)"
            class="switch-language-dropdown flex items-center gap-default justify-between text-14"
          >
            <span class="flex gap-default items-center">
              <app-icons-free-tools
                *ngIf="!iconRequireReattachment"
                [name]="languages[selectedLanguage].icon"
              ></app-icons-free-tools>
              <span
                style="
                  text-wrap: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  width: 90px;
                  text-align: left !important;
                "
                >{{ languages[selectedLanguage].name }}</span
              >
            </span>
            <app-icons name="chevronDown"></app-icons>
          </button>

          <ul
            style="display: none"
            class="language-menu p-0"
            (click)="switchLanguage($event)"
          >
            <ng-container *ngFor="let language of Object.keys(languages)">
              <ng-container
                *ngIf="languages[language].name.length; else langugeSeparator"
              >
                <li [attr.data-language]="language">
                  <app-icons-free-tools
                    [name]="languages[language].icon"
                  ></app-icons-free-tools>
                  {{ languages[language].name }}
                </li>
              </ng-container>

              <ng-template #langugeSeparator>
                <li class="lang-separator"></li>
              </ng-template>
            </ng-container>
          </ul>
        </div>
      </div>
      <div
        class="p-base flex-1 overflow-y-auto container scrollable scrollable-editor-container"
        [ngClass]="{ relative: !editorEnabled }"
      >
        <div *ngIf="showSkeleton">
          <app-skeleton
            [style]="{ height: '2rem', width: '50%', marginBottom: '1.35rem' }"
          />
          <app-skeleton
            [style]="{
              height: '1.75rem',
              width: '75%',
              marginBottom: '1.15rem'
            }"
          />
          <app-skeleton [times]="6" />
          <app-skeleton [style]="{ width: '75%', marginBottom: '1.15rem' }" />
          <app-skeleton [times]="7" />
          <app-skeleton [style]="{ width: '45%' }" />
        </div>

        <div
          #editor
          spellcheck="false"
          [ngClass]="{ 'd-none': showSkeleton }"
        ></div>

        <section
          class="container absolute inset-0 p-base pt-4"
          [ngClass]="{ 'd-none': !(!editorEnabled && !editorState.words) }"
          (click)="renderEditor()"
          style="cursor: text"
        >
          <h4 class="mb-3" style="font-size: 20px !important">
            Type or paste (Ctrl+V) your text here.
          </h4>
          <p>Or, upload a document.</p>
          <app-upload-file></app-upload-file>
        </section>

        <!-- <ng-container *ngTemplateOutlet="errorPopup" /> -->
      </div>
      <div class="p-base flex justify-between items-center container">
        <ul
          class="list-style-none gap-default m-0 p-0 text-14"
          id="editor-characters-count-list"
        >
          <li>Words: {{ f(editorState.words) }}</li>
          <li>|</li>
          <li>Characters: {{ f(editorState.characters) }}</li>
        </ul>
        <div class="flex items-center gap-default">
          <ul class="list-style-none flex gap-default m-0 p-0">
            <li>
              <button
                class="btn-outline has-tooltip"
                style="padding: 0; height: 36px; width: 36px"
                (click)="
                  quillEditor.history.undo(); computeWordsAndCharactersCount()
                "
              >
                <app-icons name="undoIcon" />

                <span class="tooltip-content tooltip-top">Undo</span>
              </button>
            </li>
            <li>
              <button
                class="btn-outline has-tooltip"
                style="padding: 0; height: 36px; width: 36px"
                (click)="
                  quillEditor.history.redo(); computeWordsAndCharactersCount()
                "
              >
                <app-icons name="redoIcon" />

                <span class="tooltip-content tooltip-top">Redo</span>
              </button>
            </li>
            <li>
              <button
                class="btn-outline has-tooltip"
                style="padding: 0; height: 36px; width: 36px"
                (click)="copyToClipboard(quillEditor.getText())"
              >
                <app-icons name="copyIcon" />

                <span class="tooltip-content tooltip-top">Copy</span>
              </button>
            </li>
            <li>
              <button
                class="btn-outline has-tooltip"
                style="padding: 0; height: 36px; width: 36px"
                (click)="clearEditor()"
              >
                <app-icons name="clearIcon" />

                <span class="tooltip-content tooltip-top">Clear</span>
              </button>
            </li>
          </ul>
          <button
            class="check-grammar-btn"
            [ngClass]="{
              'check-grammar-btn-loading':
                editorState.state === 'loading' ||
                editorState.grammarStatus === 'checking'
            }"
            (click)="
              editorState.characters === 0
                ? invokeModal($event)
                : suggestionsTone
                ? checkTone()
                : handleCheckGrammarButton()
            "
            [disabled]="
              editorState.state === 'loading' ||
              editorState.grammarStatus === 'checking'
            "
            [attr.data-target]="'empty-content-modal'"
          >
            {{
              editorState.state === "loading" ||
              editorState.grammarStatus === "checking"
                ? "Checking"
                : suggestionsTone
                ? "Check Tone"
                : "Check Grammar"
            }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <aside class="h-screen" [ngClass]="{ collapsed: resultsCollapsed }">
    <div class="grid gap-default" id="results-section-floating-buttons">
      <button id="toggle-toolbar-button">
        <app-icons name="allTools"></app-icons>

        <ul>
          <li *ngFor="let link of links">
            <button
              (click)="redirectTool(link.path)"
              class="PD2HM"
              [ngClass]="{ active: link.label === 'Grammar Checker' }"
            >
              {{ link.label }}
            </button>
          </li>
        </ul>
      </button>
      <button
        class="has-tooltip"
        (click)="invokeModal($event)"
        [attr.data-target]="'readability-modal'"
        id="toggle-readability-button"
        *ngIf="editorState.status.readability"
      >
        {{ editorState.score }}{{ editorState.score === 100 ? "" : "%" }}

        <span class="tooltip-content tooltip-left">Score</span>
      </button>
      <button
        id="results-panel-toggle"
        (click)="resultsCollapsed = !resultsCollapsed; saveToLocalStorage()"
        class="transition-base"
        [ngClass]="{
          'rotate-180': resultsCollapsed,
        }"
      >
        <app-icons name="chevronRight" />
      </button>
      <button
        class="has-tooltip"
        (click)="
          resultsCollapsed = false;
          setResultsSectionPanel(
            resultsSectionPanel === 'aiAssistant'
              ? 'resultsSection'
              : 'aiAssistant'
          )
        "
        id="toggle-ai-section"
        [ngClass]="{ active: resultsSectionPanel === 'aiAssistant' }"
      >
        <app-icons name="ai" />

        <span class="tooltip-content tooltip-left text-nowrap">
          {{
            resultsSectionPanel === "resultsSection"
              ? "AI Assistant"
              : "Show Results"
          }}
        </span>
      </button>
      <button
        class="has-tooltip"
        (click)="invokeModal($event)"
        [attr.data-target]="'set-targets-modal'"
        id="toggle-set-targets-modal"
      >
        <app-icons name="setTarget"></app-icons>

        <span class="tooltip-content tooltip-left text-nowrap">
          Set Targets
        </span>
      </button>
    </div>
    <div class="h-full flex flex-col" id="aside--inner">
      <ng-container *ngIf="resultsSectionPanel === 'resultsSection'">
        <ng-container *ngIf="editorState.status.readability > 0">
          <div
            class="flex justify-between items-center gap-sm"
            id="suggestions-section"
            [ngClass]="{
              'py-3 mb-3': selectedLanguage === 'de',
              'md-flex-col md-items-start':
                editorState.status.all && !suggestionsTone
            }"
          >
            <div
              class="font-medium gap-sm flex items-center text-15 flex-1 w-full"
              id="suggestions-container"
            >
              <span class="text-nowrap">All Suggestions</span>
              <span class="text-sm counter-badge">{{
                f(editorState.status.all)
              }}</span>
            </div>

            <div
              class="flex justify-between items-center gap-default text-sm"
              id="suggestions-section-buttons"
              [ngClass]="{
                'w-full-1600': editorState.status.all && !suggestionsTone
              }"
            >
              <ng-container *ngIf="editorState.status.all && !suggestionsTone">
                <button
                  class="flex items-center gap-sm"
                  (click)="
                    authState !== 'pro' ? invokeModal($event) : correctAll()
                  "
                  [attr.data-target]="'pricing-modal'"
                  id="correct-all-button"
                >
                  <span>
                    <app-icons name="correctAll" />
                  </span>
                  <span class="text">Correct All</span>
                </button>
              </ng-container>
              <div *ngIf="!editorState.status.all"></div>
              <div
                class="flex gap-sm has-tooltip"
                [ngClass]="{ 'd-none': selectedLanguage === 'de' }"
                id="suggestions-section-tone-toggle"
                *ngIf="authState !== 'guest'"
              >
                <span class="fw-medium">Tone</span>
                <label class="switch">
                  <input
                    type="checkbox"
                    (change)="changeSuggestionsTone()"
                    [checked]="suggestionsTone || errorsMidSuggestions"
                  />
                  <span class="slider round"></span>
                </label>
                <span class="tooltip-bottom tooltip-content">
                  {{ suggestionsTone ? "Grammar Results" : "Suggestions Tone" }}
                </span>
              </div>
            </div>
          </div>
          <div [ngClass]="{ 'd-none': selectedLanguage === 'de' }">
            <div
              class="flex gap-sm border-b pb-3 p-base overflow-x-auto scrollable"
              id="list-buttons-container"
            >
              <ng-container>
                <button
                  (click)="changeMode('all')"
                  [ngClass]="{ active: showErrorsByType === 'all' }"
                >
                  <span class="title ml-0">All</span>
                  <!-- <span class="count">{{ f(editorState.status.all) }}</span> -->
                </button>
                <button
                  class="danger has-tooltip"
                  (click)="changeMode('accMode')"
                  [ngClass]="{ active: showErrorsByType === 'accMode' }"
                >
                  <span class="title">Accuracy</span>
                  <span class="count">{{
                    f(editorState.status.accuracy)
                  }}</span>

                  <span
                    class="absolute percentage"
                    [style.right]="
                      editorState.status.accuracy
                        ? 100 -
                          (editorState.status.accuracy /
                            editorState.status.all) *
                            100 +
                          '%'
                        : 100 + '%'
                    "
                  ></span>

                  <span
                    *ngIf="checking === 'accuracy'"
                    style="position: absolute; inset: 0; z-index: -1"
                  >
                    <app-skeleton
                      [style]="{
                        height: '100%',
                        background: '#e0e0e0'
                      }"
                    ></app-skeleton>
                  </span>

                  <span class="tooltip-content tooltip-top">
                    Corrects Grammatical Mistakes
                  </span>
                </button>
                <button
                  class="info has-tooltip"
                  (click)="changeMode('clrMode')"
                  [ngClass]="{ active: showErrorsByType === 'clrMode' }"
                >
                  <span class="title">Clarity</span>
                  <span class="count">{{ editorState.status.clarity }}</span>

                  <span
                    class="absolute percentage"
                    [style.right]="
                      editorState.status.clarity
                        ? 100 -
                          (editorState.status.clarity /
                            editorState.status.all) *
                            100 +
                          '%'
                        : 100 + '%'
                    "
                  ></span>
                  <span
                    *ngIf="checking === 'clarity'"
                    style="position: absolute; inset: 0; z-index: -1"
                  >
                    <app-skeleton
                      [style]="{
                        height: '100%',
                        background: '#e0e0e0'
                      }"
                    ></app-skeleton>
                  </span>
                  <span class="tooltip-content tooltip-top">
                    Meaningful Concise Suggestions
                  </span>
                </button>
                <button
                  class="success has-tooltip"
                  (click)="changeMode('styleMode')"
                  [ngClass]="{ active: showErrorsByType === 'styleMode' }"
                >
                  <span class="title">Style</span>
                  <span class="count">{{ f(editorState.status.style) }}</span>

                  <span
                    class="absolute percentage"
                    [style.right]="
                      editorState.status.style
                        ? 100 -
                          (editorState.status.style / editorState.status.all) *
                            100 +
                          '%'
                        : 100 + '%'
                    "
                  ></span>

                  <span class="tooltip-content tooltip-top"
                    >Improves Writing</span
                  >
                </button>
                <button
                  class="warn has-tooltip"
                  (click)="changeMode('syntaxMode')"
                  [ngClass]="{ active: showErrorsByType === 'syntaxMode' }"
                >
                  <span class="title">Syntax</span>
                  <span class="count">{{ f(editorState.status.syntax) }}</span>

                  <span
                    class="absolute percentage"
                    [style.right]="
                      editorState.status.syntax
                        ? 100 -
                          (editorState.status.syntax / editorState.status.all) *
                            100 +
                          '%'
                        : 100 + '%'
                    "
                  ></span>

                  <span class="tooltip-content tooltip-top">
                    Corrects Grammatical Mistakes
                  </span>
                </button>
              </ng-container>
            </div>

            <ng-container *ngIf="suggestionsTone || errorsMidSuggestions">
              <div
                class="flex justify-between gap-sm tone-toggles border-b p-base pb-0"
              >
                <button
                  class="flex-1 has-tooltip"
                  (click)="filteredSuggestions('positive')"
                  [ngClass]="{
                    active:
                      showToneSuggestionsByType === 'positive' &&
                      !errorsMidSuggestions
                  }"
                >
                  <span class="flex gap-default items-center justify-center">
                    <span class="bullet bullet-positive"></span>
                    <span>
                      Positive ({{
                        p(editorState.status.positive, editorState.status.tone)
                      }})
                    </span>
                  </span>

                  <span class="tooltip-content tooltip-bottom text-nowrap">
                    {{ editorState.status.positive }} Suggestion{{
                      editorState.status.positive !== 1 ? "s" : ""
                    }}
                  </span>
                </button>
                <button
                  class="flex-1 has-tooltip"
                  (click)="filteredSuggestions('negative')"
                  [ngClass]="{
                    active:
                      showToneSuggestionsByType === 'negative' &&
                      !errorsMidSuggestions
                  }"
                >
                  <span class="flex gap-default items-center justify-center">
                    <span class="bullet bullet-negative"></span>
                    <span>
                      Negative ({{
                        p(editorState.status.negative, editorState.status.tone)
                      }})
                    </span>
                  </span>

                  <span class="tooltip-content tooltip-bottom text-nowrap">
                    {{ editorState.status.negative }} Suggestion{{
                      editorState.status.negative !== 1 ? "s" : ""
                    }}
                  </span>
                </button>
                <button
                  class="flex-1 has-tooltip"
                  (click)="filteredSuggestions('neutral')"
                  [ngClass]="{
                    active:
                      showToneSuggestionsByType === 'neutral' &&
                      !errorsMidSuggestions
                  }"
                >
                  <span class="flex gap-default items-center justify-center">
                    <span class="bullet bullet-neutral"></span>
                    <span>
                      Neutral ({{
                        p(editorState.status.neutral, editorState.status.tone)
                      }})
                    </span>
                  </span>

                  <span class="tooltip-content tooltip-bottom text-nowrap">
                    {{ editorState.status.neutral }} Suggestion{{
                      editorState.status.neutral !== 1 ? "s" : ""
                    }}
                  </span>
                </button>
              </div>
            </ng-container>
          </div>

          <div
            class="flex-1 overflow-hidden"
            [ngClass]="{ 'border-t': selectedLanguage === 'de' }"
            *ngIf="
              !suggestionsTone && Object.keys(editorState.filteredErrors).length
            "
            id="corrections-container-parent"
          >
            <ul
              class="p-base overflow-y-auto mh-100 scrollable"
              id="corrections-container"
            >
              @for (el of Object.keys(editorState.filteredErrors); track el) {
              @for (errors of editorState.filteredErrors[el]; track errors) {
              @for (error of [errors]; track error) { @if (error.errorType ===
              'modAcc' || error.errorType === 'modClr') { @if (!(error.errorType
              === 'modClr' && ['guest', 'auth'].includes(authState)) ||
              error.unlocked) {
              <li
                [attr.data-error]="'err-' + error.highlights[0].tread_id"
                (mouseenter)="highlightErrorInEditor($event, error.ColorLight)"
                (mouseleave)="removeHighlightInEditor($event)"
              >
                <button
                  class="w-full expand-toggler"
                  (click)="toggleErrorListExpand($event, error.ColorLight)"
                >
                  <span class="flex gap-lg items-center">
                    <span
                      class="pill"
                      [ngClass]="
                        error.errorType === 'modAcc'
                          ? 'pill-danger'
                          : 'pill-info'
                      "
                    ></span>
                    <span class="error-text fw-medium text-15 error-wrong">{{
                      error.highlights[0].wrong
                    }}</span>
                  </span>
                  <span class="error-list-type text-14"
                    >Correct {{ error.highlights[0].model }}</span
                  >
                </button>

                <div
                  class="error-card-header items-center gap-lg"
                  (click)="toggleErrorListExpand($event, error.ColorLight)"
                  title="Toggle Expanded"
                >
                  <span
                    class="pill"
                    [ngClass]="
                      error.errorType === 'modAcc' ? 'pill-danger' : 'pill-info'
                    "
                  ></span>
                  <span class="error-type fw-medium text-15">{{
                    error.highlights[0].model
                  }}</span>
                </div>

                <div class="error-text-paragraph-container">
                  <p
                    class="error-text-paragraph overflow-y-auto mb-1 text-14"
                    [innerHTML]="formatReplacementsArray(error.replacements[0])"
                  ></p>
                </div>

                <div class="error-card-footer">
                  <div class="flex gap-default justify-end text-14">
                    <button
                      class="flex gap-sm btn-secondary text-center text-14 dismiss-button"
                      style="
                        height: 34px;
                        width: 150px;
                        text-align: center !important;
                        font-size: 14px;
                      "
                      [attr.data-target]="'err-' + error.highlights[0].tread_id"
                      (click)="handleDismiss($event, error.errorType)"
                    >
                      <span>Dismiss</span>
                    </button>
                    <button
                      class="correction-button accept-button"
                      style="
                        height: 34px;
                        width: 150px;
                        text-align: center !important;
                        font-size: 14px;
                      "
                      [attr.data-model]="error.errorType"
                      [attr.data-target]="'err-' + error.highlights[0].tread_id"
                      [attr.data-correction]="
                        JSON.stringify(error.replacements[0])
                      "
                      [attr.data-correct]="error.correct"
                      (click)="handleCorrection($event)"
                    >
                      Accept
                    </button>
                  </div>

                  <button
                    (click)="toggleReportMenu($event)"
                    *ngIf="authState !== 'guest'"
                  >
                    <app-icons name="toggleMenu"></app-icons>
                  </button>

                  <ul style="display: none" class="report-menu p-0">
                    <li
                      (click)="reportSuggestion($event)"
                      [attr.data-rule]="error.rule.id"
                      [attr.data-text]="error.wrong"
                      class="flex gap-default"
                    >
                      <app-icons name="reportSuggestion"></app-icons>

                      <span class="action">Report Suggestion</span>
                    </li>
                  </ul>
                </div>
              </li>
              }
              <!-- @else {
              <li class="premium-suggestion">
                <div class="content">
                  <button class="w-full expand-toggler p-base blur">
                    <span class="flex gap-lg items-center">
                      <span
                        class="pill"
                        [ngClass]="
                          error.errorType === 'modAcc'
                            ? 'pill-danger'
                            : 'pill-info'
                        "
                      ></span>
                      <span class="error-text text-15">{{
                        error.highlights[0].wrong
                      }}</span>
                    </span>

                    <span class="error-list-type text-14"
                      >Correct {{ error.highlights[0].model }}</span
                    >
                  </button>
                  <div
                    class="flex gap-sm items-center premium-content-container"
                  >
                    <ng-container
                      *ngTemplateOutlet="appPremiumTemplate"
                    ></ng-container>
                  </div>
                </div>
              </li>
              } -->
              } @if (error.errorType === 'accuracy' || error.errorType ===
              'style' || error.errorType === 'clarity' || error.errorType ===
              'syntax') { @if ( ! ( ( ['guest', 'auth'].includes(authState) &&
              !(['accuracy', 'clarity'].includes(error.errorType) &&
              error.errorType === 'accuracy' || error.unlocked ) ) ) ) {
              <!-- <li class="premium-suggestion">
                <div class="content">
                  <button class="w-full expand-toggler p-base blur">
                    <span class="flex gap-lg items-center">
                      <span
                        class="pill"
                        [style.background-color]="error.Color"
                      ></span>
                      <span class="error-text text-15">{{ error.wrong }}</span>
                    </span>
                    <span class="error-list-type text-14"
                      >Correct {{ error.errorType }}</span
                    >
                  </button>

                  <div
                    class="flex gap-sm items-center premium-content-container"
                  >
                    <ng-container
                      *ngTemplateOutlet="appPremiumTemplate"
                    ></ng-container>
                  </div>
                </div>
              </li>

              } @else { -->
              <li
                [attr.data-error]="'err-' + error.ChkiD + '-' + error.offset"
                (mouseenter)="highlightErrorInEditor($event, error.ColorLight)"
                (mouseleave)="removeHighlightInEditor($event)"
              >
                <button
                  class="w-full expand-toggler"
                  (click)="toggleErrorListExpand($event, error.ColorLight)"
                >
                  <span class="flex gap-lg items-center">
                    <span
                      class="pill"
                      [style.background-color]="error.Color"
                    ></span>
                    <span class="fw-medium text-15 error-wrong">{{
                      error.wrong
                    }}</span>
                  </span>
                  <span class="error-list-type text-14"
                    >Correct {{ error.errorType }}</span
                  >
                </button>

                <div
                  class="error-card-header items-center gap-lg"
                  (click)="toggleErrorListExpand($event, error.ColorLight)"
                >
                  <span
                    class="pill"
                    [style.background-color]="error.Color"
                  ></span>
                  <span class="error-type fw-medium text-15">{{
                    error.errorType
                  }}</span>
                </div>

                <div class="error-text-paragraph-container mt-1">
                  <div class="error-text-paragraph overflow-y-auto text-14">
                    @if (error.replacements.length > 0) {
                    <div class="flex gap-sm mode-error-correction">
                      <span class="error-text">{{ error.wrong }}</span>
                      <button
                        class="corrected-text"
                        [attr.data-target]="
                          'err-' + error.ChkiD + '-' + error.offset
                        "
                        (click)="handleCorrection($event)"
                        [attr.data-correction]="error.replacements[0].value"
                      >
                        {{ error.replacements[0]?.value }}
                      </button>
                    </div>
                    }

                    <div class="my-3" *ngIf="error.replacements.length > 1">
                      <span>Suggestion(s):</span>
                      <div class="flex gap-sm my-1">
                        @for (replacement of error.replacements.slice(1, 5);
                        track replacement) {
                        <button
                          class="btn-outline px-2 py-1"
                          [attr.data-target]="
                            'err-' + error.ChkiD + '-' + error.offset
                          "
                          (click)="handleCorrection($event)"
                          [attr.data-correction]="replacement.value"
                        >
                          {{ replacement.value }}
                        </button>
                        }
                      </div>
                    </div>

                    <p class="pb-0 mb-0 mt-3">
                      <strong>Description: </strong>
                      <em>{{ error.message }}</em>
                    </p>
                  </div>
                </div>

                <div class="error-card-footer mt-2">
                  <button
                    class="flex gap-sm btn-secondary text-center text-14 dismiss-button"
                    style="
                      height: 34px;
                      width: 150px;
                      text-align: center !important;
                      font-size: 14px;
                    "
                    [attr.data-target]="
                      'err-' + error.ChkiD + '-' + error.offset
                    "
                    (click)="handleDismiss($event)"
                  >
                    <span>Dismiss</span>
                  </button>
                  <button
                    (click)="toggleReportMenu($event)"
                    *ngIf="authState !== 'guest'"
                  >
                    <app-icons name="toggleMenu"></app-icons>
                  </button>

                  <ul style="display: none" class="report-menu p-0">
                    <li
                      *ngIf="error.replacements[0]?.value"
                      class="flex gap-default"
                      (click)="addWordToDictionary(error.wrong)"
                    >
                      <app-icons name="addDictionary"></app-icons>

                      Add to Dictionary
                    </li>
                    <li
                      (click)="reportSuggestion($event)"
                      [attr.data-text]="error.text"
                      [attr.data-rule]="error.rule.id"
                      class="flex gap-default"
                    >
                      <app-icons name="reportSuggestion"></app-icons>

                      <span class="action"> Report Suggestion </span>
                    </li>
                  </ul>
                </div>
              </li>

              } } } } }
              <!-- @if (authState === 'guest') {
              @if(quillEditor.root.querySelectorAll('.E93fKL-PD_2').length) {
              <li class="premium-suggestion">
                <div class="content">
                  <p class="p-base pb-0 mb-1 fw-medium">
                    Login to increase limit or upgrade to Grammarin Pro to
                    unlock all suggestions.
                  </p>

                  <div
                    class="flex gap-sm items-center premium-content-container"
                  >
                    <ng-container
                      *ngTemplateOutlet="appPremiumTemplate"
                    ></ng-container>
                  </div>
                </div>
              </li>
            } } -->
              @if (['guest', 'auth'].includes(authState) && ['all',
              'clrMode'].includes(showErrorsByType)) {
              <li class="premium-suggestion" id="9eymM-HtPD2M-clr">
                <div class="content pb-3">
                  <div
                    class="error-card-header flex items-center gap-lg pt-3 mx-3"
                  >
                    <span class="pill pill-info"></span>
                    <span class="error-type fw-medium text-15">Clarity</span>
                  </div>
                  <div
                    class="error-text-paragraph-container blur p-base pb-1"
                    *ngFor="let error of getFirstFewClarityErrors()"
                  >
                    <p
                      class="error-paragraph-premium mb-1 text-14 pe-none user-select-none"
                      [innerHTML]="error"
                    ></p>
                  </div>
                  <div
                    class="flex gap-sm items-center premium-content-container"
                  >
                    <div class="flex gap-default items-center">
                      <img
                        src="../../../assets/images/editorimages/premium-user-animation.webp"
                        alt=""
                        width="53"
                        height="53"
                      />
                      <p
                        *ngIf="editorState.status.clarity_locked"
                        class="mb-0 fw-medium"
                      >
                        Unlock {{ editorState.status.clarity_locked }} more
                        premium suggestion{{
                          editorState.status.clarity_locked > 1 ? "s" : ""
                        }}.
                      </p>
                      <p
                        *ngIf="!editorState.status.clarity_locked"
                        class="mb-0 fw-medium"
                      >
                        Enhance by unlocking additional features!
                      </p>
                    </div>

                    <div class="flex-1">
                      <button
                        (click)="invokeModal($event)"
                        [attr.data-target]="'pricing-modal'"
                        class="upgrade-pro"
                      >
                        <app-icons name="premiumDiamondIcon" />
                        <span>{{
                          editorState.status.clarity_locked
                            ? "Enhance Clarity"
                            : "View Suggestions"
                        }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </li>
              } @if (['guest', 'auth'].includes(authState) && ['all',
              'styleMode'].includes(showErrorsByType)) {
              <li class="premium-suggestion" id="9eymM-HtPD2M-sty">
                <div class="content pb-3">
                  <div
                    class="error-card-header flex items-center gap-lg pt-3 mx-3"
                  >
                    <span
                      class="pill"
                      style="background-color: rgb(51, 182, 108)"
                    ></span>
                    <span class="error-type fw-medium text-15">Style</span>
                  </div>
                  <div class="error-text-paragraph-container blur p-base pb-1">
                    <p
                      class="error-text-paragraph overflow-y-auto mb-1 text-14"
                      *ngFor="let error of getFirstFewStyleErrors()"
                    >
                      {{ error }}
                    </p>
                  </div>
                  <div
                    class="flex gap-sm items-center premium-content-container"
                  >
                    <div class="flex gap-default items-center">
                      <img
                        src="../../../assets/images/editorimages/premium-user-animation.webp"
                        alt=""
                        width="53"
                        height="53"
                      />
                      <p
                        class="mb-0 fw-medium"
                        *ngIf="editorState.status.style"
                      >
                        Unlock {{ editorState.status.style }} more premium
                        suggestion{{ editorState.status.style > 1 ? "s" : "" }}.
                      </p>
                      <p
                        class="mb-0 fw-medium"
                        *ngIf="!editorState.status.style"
                      >
                        Enhance by unlocking additional features!
                      </p>
                    </div>

                    <div class="flex-1">
                      <button
                        (click)="invokeModal($event)"
                        [attr.data-target]="'pricing-modal'"
                        class="upgrade-pro"
                      >
                        <app-icons name="premiumDiamondIcon" />
                        <span>{{
                          editorState.status.style
                            ? "Enhance Style"
                            : "View Suggestions"
                        }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </li>
              } @if (['guest', 'auth'].includes(authState) && ['all',
              'syntaxMode'].includes(showErrorsByType)) {
              <li class="premium-suggestion" id="9eymM-HtPD2M-syn">
                <div class="content pb-3">
                  <div
                    class="error-card-header flex items-center gap-lg pt-3 mx-3"
                  >
                    <span class="pill" style="background-color: #f87f11"></span>
                    <span class="error-type fw-medium text-15">Syntax</span>
                  </div>
                  <div class="error-text-paragraph-container blur p-base pb-1">
                    <!-- <p
                      class="error-text-paragraph overflow-y-auto mb-1 text-14"
                      *ngFor="let error of getFirstFewStyleErrors()"
                    >
                      {{ error }}
                    </p> -->
                  </div>
                  <div
                    class="flex gap-sm items-center premium-content-container"
                  >
                    <div class="flex gap-default items-center">
                      <img
                        src="../../../assets/images/editorimages/premium-user-animation.webp"
                        alt=""
                        width="53"
                        height="53"
                      />
                      <p
                        class="mb-0 fw-medium"
                        *ngIf="editorState.status.syntax"
                      >
                        Unlock {{ editorState.status.syntax }} more premium
                        suggestion{{
                          editorState.status.syntax > 1 ? "s" : ""
                        }}.
                      </p>
                      <p
                        class="mb-0 fw-medium"
                        *ngIf="!editorState.status.syntax"
                      >
                        Enhance by unlocking additional features!
                      </p>
                    </div>

                    <div class="flex-1">
                      <button
                        (click)="invokeModal($event)"
                        [attr.data-target]="'pricing-modal'"
                        class="upgrade-pro"
                      >
                        <app-icons name="premiumDiamondIcon" />
                        <span>{{
                          editorState.status.syntax
                            ? "Enhance Syntax"
                            : "View Suggestions"
                        }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </li>
              }
            </ul>
            <ng-template #emptyErrorsTemplate>
              <section class="h-full grid place-items-center">
                <app-empty-content content="errors"></app-empty-content>
              </section>
            </ng-template>
          </div>

          <div
            class="grid gap-default p-base flex-1 border-b"
            *ngIf="
              editorState.state === 'loading' &&
              !suggestionsTone &&
              !Object.keys(editorState.filteredErrors).length
            "
          >
            <app-errors-loader></app-errors-loader>
            <!-- <div class="flex-1 border-b p-base grid place-items-center">
              <div class="flex items-center flex-col">
                <img
                  src="../../assets/images/editorimages/placeholders/editor-page-no-errors-telescope.avif"
                  alt=""
                  width="80"
                  height="80"
                  loading="eager"
                  class="mx-auto"
                />
                <p>Looking for errors...</p>
              </div>
            </div> -->
          </div>

          <ng-container *ngIf="!suggestionsTone">
            <ng-container
              *ngIf="
                editorState.state !== 'loading' &&
                !Object.keys(editorState.filteredErrors).length
              "
            >
              <div class="flex-1 grid place-items-center">
                <section>
                  <app-empty-content content="errors"></app-empty-content>
                </section>
              </div>
            </ng-container>
          </ng-container>

          <ng-container
            *ngIf="
              suggestionsTone &&
              !errorsMidSuggestions &&
              !Object.keys(editorState.filteredSuggestions).length
            "
          >
            <div class="flex-1 grid place-items-center">
              <section>
                <app-empty-content content="errors"></app-empty-content>
              </section>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              suggestionsTone &&
              Object.keys(editorState.filteredSuggestions).length
            "
          >
            <div
              class="flex-1 overflow-hidden"
              id="corrections-container-parent"
            >
              <ul
                class="p-base overflow-y-auto mh-100"
                id="corrections-container"
              >
                @for (chunk of Object.keys(editorState.filteredSuggestions);
                track chunk) { @for (highlight of
                editorState.filteredSuggestions[chunk]; track highlight) {
                <li
                  [attr.data-error]="highlight.id"
                  (mouseenter)="
                    highlightErrorInEditor(
                      $event,
                      highlight.category === 'Positive'
                        ? 'var(--editor-primary-light)'
                        : highlight.category === 'Negative'
                        ? 'var(--editor-danger-secondary-light)'
                        : 'var(--editor-info-light)'
                    )
                  "
                  (mouseleave)="removeHighlightInEditor($event)"
                >
                  <button
                    class="w-full expand-toggler"
                    (click)="
                      toggleErrorListExpand(
                        $event,
                        highlight.category === 'Positive'
                          ? 'var(--editor-primary-light)'
                          : highlight.category === 'Negative'
                          ? 'var(--editor-danger-secondary-light)'
                          : 'var(--editor-info-light)'
                      )
                    "
                    [attr.data-target]="highlight.id"
                  >
                    <span class="flex gap-default items-center">
                      <span
                        class="pill"
                        [ngClass]="'pill-' + highlight.category.toLowerCase()"
                      ></span>
                      <span
                        class="error-category font-medium text-15"
                        [ngClass]="
                          'text-color-' + highlight.category.toLowerCase()
                        "
                        >{{ highlight.category }}</span
                      >
                    </span>

                    <span class="corrected-text text-14">{{
                      highlight.text
                    }}</span>
                  </button>

                  <div class="error-card-header items-center gap-lg">
                    <span
                      class="pill"
                      [ngClass]="'pill-' + highlight.category.toLowerCase()"
                    ></span>
                    <span class="error-type fw-medium text-15">{{
                      highlight.category
                    }}</span>
                  </div>
                  <div class="error-text-paragraph-container">
                    <p class="error-text-paragraph overflow-y-auto text-14">
                      {{ highlight.message }}
                    </p>
                  </div>

                  <div class="error-card-footer">
                    <button
                      class="flex gap-sm btn-secondary text-center text-14 dismiss-button"
                      style="
                        height: 34px;
                        width: 150px;
                        text-align: center !important;
                        font-size: 14px;
                      "
                      (click)="handleToneErrorDismiss($event)"
                      [attr.data-target]="highlight.id"
                    >
                      <span>Dismiss</span>
                    </button>
                    <button
                      (click)="toggleReportMenu($event)"
                      *ngIf="authState !== 'guest'"
                    >
                      <app-icons name="toggleMenu"></app-icons>
                    </button>

                    <ul style="display: none" class="report-menu p-0">
                      <li
                        (click)="reportSuggestion($event)"
                        [attr.data-rule]="highlight.label"
                        [attr.data-text]="highlight.text"
                        class="flex gap-default"
                      >
                        <app-icons name="reportSuggestion"></app-icons>

                        <span class="action"> Report Suggestion </span>
                      </li>
                    </ul>
                  </div>
                </li>
                }}
              </ul>
            </div>
          </ng-container>

          <div class="flex p-base gap-sm font-medium">
            <button
              class="flex-1 btn-secondary hover-bg-primary text-center"
              style="border-radius: 0.75rem; font-size: 15px"
              (click)="
                authState === 'guest'
                  ? invokeModal($event)
                  : redirectToTool('ai-content-detector')
              "
              [attr.data-target]="'pricing-modal'"
            >
              @if (authState === 'pro') { AI Content Detect{{
                editorState.aiContentScore
                  ? "ed (" + editorState.aiContentScore + "%)"
                  : "or (0%)"
              }}
              } @else { AI Content Detect{{
                editorState.aiContentScore ? "ed" : "or"
              }}
              }
            </button>
            <button
              class="flex-1 btn-secondary hover-bg-dark text-center"
              style="border-radius: 0.75rem; font-size: 15px"
              (click)="
                authState === 'guest'
                  ? invokeModal($event)
                  : redirectToTool('plagiarism-checker')
              "
              [attr.data-target]="'pricing-modal'"
            >
              @if (authState === 'pro') { Plagiarism
              {{
                editorState.plagiarism.plagiarismScore
                  ? "Detected (" + editorState.plagiarism.plagiarismScore + "%)"
                  : "Checker (0%)"
              }}
              } @else { Plagiarism
              {{
                editorState.plagiarism.isPlagiarized ? "Detected" : "Checker"
              }}
              }
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="editorState.status.readability === 0">
          <div class="p-base grid place-items-center h-full">
            <app-empty-content content="content"></app-empty-content>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="resultsSectionPanel === 'aiAssistant'">
        <div class="p-base border-b" *ngIf="!aiAssistantQueries.length">
          <button
            class="btn-secondary text-14 fw-medium px-3 flex items-center gap-sm"
            style="border-radius: 0.75rem; width: 200px; height: 40px"
            (click)="resultsSectionPanel = 'resultsSection'"
          >
            <span class="pt-1">
              <app-icons name="backIcon"></app-icons>
            </span>
            <span> Back to suggestions </span>
          </button>
        </div>
        <section
          class="grid place-items-center flex-1 p-base overflow-y-auto"
          *ngIf="!aiAssistantQueries.length"
        >
          <div class="grid gap-sm text-center">
            <div class="ai-assistant-animation-container">
              <img
                src="../../assets/images/editorimages/ai-chatbot-animation.webp"
                alt=""
                width="80"
                height="80"
                loading="lazy"
                class="mx-auto"
              />
            </div>

            <h1 class="font-semibold mb-0 mt-1" style="font-size: 20px">
              Looking to get started?
            </h1>
            <em class="text-14">Here are some ideas for you.</em>
            <div class="gap-sm" id="ai-suggestions-buttons-container">
              <button
                class="flex items-center gap-sm text-15"
                (click)="handleAiAssistantResponse($event)"
              >
                <app-icons name="improveIcon" />
                <span>Improve it</span>
              </button>
              <button
                class="flex items-center gap-sm text-15"
                (click)="handleAiAssistantResponse($event)"
              >
                <app-icons name="findIcon" />
                <span>Find claims I should cite</span>
              </button>
            </div>
          </div>
        </section>

        <ng-container *ngIf="aiAssistantQueries.length">
          <div class="flex justify-between items-center p-base border-b">
            <button
              class="btn-secondary text-14 fw-medium px-3 flex items-center gap-sm"
              style="border-radius: 0.75rem; width: 200px; height: 40px"
              (click)="resultsSectionPanel = 'resultsSection'"
            >
              <span class="pt-1">
                <app-icons name="backIcon"></app-icons>
              </span>
              <span> Back to suggestions </span>
            </button>

            <p class="text-sm mb-0">
              {{ f(authLimits[authState].prompts - promptsUsed) }}/{{
                f(authLimits[authState].prompts)
              }}
              Prompts Left
            </p>
          </div>

          <div
            class="p-base flex flex-col flex-1 justify-end overflow-y-auto"
            (scroll)="handleUserInteraction('scroll')"
            (click)="handleUserInteraction()"
            #messagesContainer
          >
            <div class="max-h-full">
              @for (query of aiAssistantQueries; track query) {
              <section class="ai-assistant-message-container">
                <h2 class="text-base">{{ query.question }}</h2>
                <div
                  class="markdown-container"
                  *ngIf="
                    authState !== 'guest' && query.answer !== 'Upgrade';
                    else upgradeAccountPopup
                  "
                >
                  <ngx-typed-writer
                    *ngIf="!query.loaded && allowTypeWriter"
                    [typeSpeed]="5"
                    [strings]="[
                      query.answer.length ? query.answer : 'No response...'
                    ]"
                    [loop]="false"
                    (completeLoop)="query.loaded = true; saveToLocalStorage()"
                  ></ngx-typed-writer>
                  <markdown *ngIf="query.loaded">{{
                    query.answer.length ? query.answer : "_No response..._"
                  }}</markdown>

                  <div class="flex justify-end">
                    <button
                      type="button"
                      (click)="copyAiAssistantResponse($event)"
                      class="p-0 has-tooltip"
                      *ngIf="query.answer.length"
                    >
                      <app-icons name="copyIcon" />

                      <span class="tooltip-content tooltip-top">Copy</span>
                    </button>
                  </div>
                </div>

                <ng-template #upgradeAccountPopup>
                  <div class="mb-4">
                    <app-premium-user />
                  </div>
                </ng-template>
              </section>
              }

              <section
                *ngIf="isAiAssistantQueriesLoading"
                class="ai-assistant-message-container"
              >
                <h2 class="text-base">Loading...</h2>
                <div class="markdown-container">Generating Response...</div>
              </section>

              <!-- <div class="mb-3" id="ai-suggestions-buttons-container">
                <button
                  class="flex items-center gap-default"
                  (click)="handleAiAssistantResponse($event)"
                >
                  <app-icons name="improveIcon" />
                  <span>Improve it</span>
                </button>
                <button
                  class="flex items-center gap-default"
                  (click)="handleAiAssistantResponse($event)"
                >
                  <app-icons name="findIcon" />
                  <span>Find claims I should cite</span>
                </button>
              </div> -->
              <div class="gap-sm mb-3" id="ai-suggestions-buttons-container">
                <button
                  class="flex items-center gap-sm text-15"
                  (click)="handleAiAssistantResponse($event)"
                >
                  <app-icons name="improveIcon" />
                  <span>Improve it</span>
                </button>
                <button
                  class="flex items-center gap-sm text-15"
                  (click)="handleAiAssistantResponse($event)"
                >
                  <app-icons name="findIcon" />
                  <span>Find claims I should cite</span>
                </button>
              </div>

              <div class="pb-2px"></div>
            </div>
          </div>
        </ng-container>

        <div class="flex p-base font-medium border-t">
          <form
            class="w-full"
            action="#"
            (submit)="handleAiAssistantResponse($event)"
          >
            <input
              type="text"
              name="text"
              id="ai-assistant-input"
              class="p-base w-full"
              [placeholder]="
                isAiAssistantQueriesLoading
                  ? 'Generating Response...'
                  : 'Ask any thing...'
              "
              required
              [disabled]="isAiAssistantQueriesLoading"
              autocomplete="off"
            />
          </form>
        </div>
      </ng-container>
    </div>
  </aside>

  <app-modal parent="set-targets-modal">
    <modal-content>
      <div class="flex justify-end">
        <button (click)="dismissModal($event)">
          <app-icons name="closeModalIcon"></app-icons>
        </button>
      </div>
      <div class="p-base grid gap-default col-11 pt-0">
        <div class="row gap-default items-center">
          <div class="col">
            <app-icons name="setTargetsModal"></app-icons>
          </div>
          <div class="col-9">
            <h3 class="mt-3">Set Goals</h3>
            <p>
              Get tailored writing suggestions based on your goals and audience.
            </p>
          </div>
        </div>

        <div class="grid gap-sm">
          <h4>Domain</h4>
          <div class="modal-settings-button flex gap-sm">
            <button
              class="btn-secondary hover-bg-primary text-center"
              [ngClass]="{ active: editorState.domain === 'academic' }"
              (click)="
                editorState.domain = 'academic';
                editorState.formality = 'formal'
              "
            >
              Academic
            </button>
            <button
              class="btn-secondary hover-bg-primary text-center"
              [ngClass]="{ active: editorState.domain === 'general' }"
              (click)="editorState.domain = 'general'"
            >
              General
            </button>
          </div>
          <p *ngIf="editorState.domain === 'academic'">
            Academic: Complex formal writing with strict principles and
            proficient grammar usage.
          </p>
          <p *ngIf="editorState.domain === 'general'">
            General: Easy for anyone to read with minimal effort.
          </p>
        </div>

        <div class="grid gap-sm">
          <h4>Formality</h4>
          <div class="modal-settings-button flex gap-sm">
            <button
              class="btn-secondary hover-bg-primary text-center"
              [ngClass]="{ active: editorState.formality === 'formal' }"
              (click)="editorState.formality = 'formal'"
              [disabled]="editorState.domain === 'academic'"
            >
              Formal
            </button>
            <button
              class="btn-secondary hover-bg-primary text-center"
              [ngClass]="{ active: editorState.formality === 'neutral' }"
              (click)="editorState.formality = 'neutral'"
              [disabled]="editorState.domain === 'academic'"
            >
              Neutral
            </button>
            <button
              class="btn-secondary hover-bg-primary text-center"
              [ngClass]="{ active: editorState.formality === 'informal' }"
              (click)="editorState.formality = 'informal'"
              [disabled]="editorState.domain === 'academic'"
            >
              Informal
            </button>
          </div>
          <p *ngIf="editorState.formality === 'formal'">
            Formal: Official language use, following standard and strict rules.
          </p>
          <p *ngIf="editorState.formality === 'neutral'">
            Neutral: Clear and professional without being too formal or casual.
          </p>
          <p *ngIf="editorState.formality === 'informal'">
            Informal: Casual and spontaneous use of language.
          </p>
        </div>
        <div>
          <div class="form-check mb-1">
            <input
              class="form-check-input"
              type="checkbox"
              id="show-set-targets-checkbox"
              [checked]="showTargetsCheckboxValue"
              (change)="showTargetsCheckboxValue = !showTargetsCheckboxValue"
            />
            <label class="form-check-label" for="show-set-targets-checkbox">
              Show Set Targets when I start a new document.
            </label>
          </div>
          <button
            class="check-grammar-btn"
            (click)="
              updateShowTargetsOnLoad();
              handleCheckGrammarButton();
              dismissModal($event)
            "
          >
            Set Targets
          </button>
        </div>
      </div>
    </modal-content>
  </app-modal>

  <app-modal parent="readability-modal">
    <modal-content>
      <div class="p-base flex h-full flex-col gap-default">
        <h3>Complete Score</h3>

        <div class="flex-1">
          <div class="row gap-default items-center">
            <div class="col-9 modal-settings-button grid gap-default">
              <div>
                <h4 class="readability-modal-heading">Performance</h4>
              </div>

              <p class="mb-0">
                <strong>Text Score</strong>:
                <strong>{{ editorState.score }}</strong> out of
                <strong>100</strong>. This score represents the quality of
                writing in this document. You can increase it by addressing
                GrammarIn suggestions.
              </p>
            </div>
            <div class="col-2 text-center">
              <circle-progress
                [percent]="editorState.score"
                [outerStrokeWidth]="5"
                [innerStrokeWidth]="5"
                [innerStrokeColor]="'#EFEEEB'"
                [outerStrokeColor]="
                  editorState.score >= 80 ? '#08ba9c' : '#df2148'
                "
                [space]="-5"
                [renderOnClick]="false"
                [radius]="50"
                [outerStrokeLinecap]="'square'"
                [clockwise]="false"
              ></circle-progress>
            </div>
          </div>

          <hr />

          <div class="modal-settings-button grid gap-default">
            <div>
              <h4 class="readability-modal-heading">Word Count</h4>
            </div>

            <ul class="row p-0 mb-0">
              <li class="col-6 flex justify-between gap-default">
                <strong>Characters</strong>
                <span>{{ f(editorState.characters) }}</span>
              </li>
              <li class="col-6 flex justify-between gap-default">
                <strong>Reading Time</strong>
                <span>{{
                  formatTime(editorState.status.reading_time) || "1s"
                }}</span>
              </li>
              <li class="col-6 flex justify-between gap-default">
                <strong>Word</strong>
                <span>{{ f(editorState.words) }}</span>
              </li>
              <li class="col-6 flex justify-between gap-default">
                <strong>Speaking time</strong>
                <span>{{
                  formatTime(editorState.status.speaking_time) || "1s"
                }}</span>
              </li>
              <li class="col-6 flex justify-between gap-default">
                <strong>Sentences</strong>
                <span>{{ f(editorState.sentences) }}</span>
              </li>
            </ul>
          </div>

          <hr />

          <div class="modal-settings-button grid gap-default">
            <div class="flex items-center gap-default">
              <h4 class="readability-modal-heading mb-0">Readability</h4>
            </div>

            <ul class="p-0 mb-0">
              <li class="row gap-default">
                <span class="col-6 flex justify-between">
                  <strong>Word length</strong>
                  <span>{{ f(editorState.wordsLength) }}</span>
                </span>
              </li>
              <li class="row gap-default">
                <span class="col-6 flex justify-between">
                  <strong>Sentence Length</strong>
                  <span>{{ f(editorState.sentenceLength) }}</span>
                </span>
              </li>
              <li class="row gap-default">
                <span class="col-6 flex justify-between">
                  <strong>Readability</strong>
                  <span>{{ editorState.score }}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <hr />

        <div class="flex justify-between items-center">
          <button
            class="check-grammar-btn flex gap-default"
            (click)="downloadReadabilityReport()"
            *ngIf="!suggestionsTone"
          >
            <app-icons name="downloadIcon"></app-icons>
            <span>Download Report</span>
          </button>
          <span *ngIf="suggestionsTone"></span>
          <button
            class="check-grammar-btn w-unset"
            (click)="dismissModal($event)"
            style="max-width: unset !important"
          >
            Close
          </button>
        </div>
      </div>
    </modal-content>
  </app-modal>

  <app-modal parent="empty-content-modal">
    <modal-content>
      <section class="text-center grid justify-center">
        <h3>Enter at least 1 word.</h3>

        <p>Please enter at least 1 word to proceed.</p>

        <div>
          <button
            class="check-grammar-btn w-unset"
            (click)="dismissModal($event)"
            style="max-width: unset !important"
          >
            Dismiss
          </button>
        </div>
      </section>
    </modal-content>
  </app-modal>

  <app-modal parent="content-exceeds-words-limit-modal">
    <modal-content>
      <section class="text-center grid justify-center">
        <h3>Content Exceeds Words Limit</h3>

        <p>
          Please reduce your content to less than
          {{ f(10000) }} words.
        </p>

        <div>
          <button
            class="check-grammar-btn w-unset"
            (click)="dismissModal($event)"
            style="max-width: unset !important"
          >
            Dismiss
          </button>
        </div>
      </section>
    </modal-content>
  </app-modal>

  @if (authState !== 'pro') {
  <app-modal parent="upgrade-to-premium-modal">
    <modal-content>
      <section>
        <h5>
          Login to unlock this feature or upgrade to Premium to access all
          features.
        </h5>

        <app-premium-user></app-premium-user>
        <div class="flex justify-end">
          <button
            class="check-grammar-btn w-unset mt-3"
            (click)="dismissModal($event)"
            style="max-width: unset !important"
          >
            Dismiss
          </button>
        </div>
      </section>
    </modal-content>
  </app-modal>

  <app-modal
    parent="pricing-modal"
    [style]="{
      borderRadius: '0.75rem',
      border: '1px solid oklch(0.82 0.1471 171.99 / 25.5%)'
    }"
  >
    <modal-content>
      <section>
        <div class="flex justify-between">
          <h3 class="mt-1 mb-0">Grammarin Premium</h3>

          <button (click)="dismissModal($event)">
            <app-icons name="closeModalIcon"></app-icons>
          </button>
        </div>

        <p class="fw-medium">Upgrade your plan to unlock all features.</p>

        <app-premium [heading]="false" />

        <!-- <ul
          class="grid gap-default list-style-none m-0 mb-2 p-0"
          id="pricing-list"
        >
          @for (plan of plans; track plan.id) {
          <li class="grid gap-sm">
            <div class="flex gap-default justify-between items-center">
              <h4 class="text-base fw-medium p-0 m-0">{{ plan.name }}</h4>
              <span class="discount-badge fw-medium"
                >{{ plan.discount }} OFF</span
              >
            </div>
            <div class="flex gap-default justify-between items-center mb-3">
              <h5 class="fs-3 fw-bold p-0 m-0">{{ plan.price }}</h5>
              <s class="fw-medium" style="font-size: 0.85rem">{{
                plan.originalPrice
              }}</s>
            </div>
            <button (click)="selectPlan(plan.id)">Select Plan</button>
          </li>
          }
        </ul> -->

        <div class="flex flex-col items-center mt-3">
          <a href="/pricing" target="_blank" class="upgrade-to-premium-button">
            View All
          </a>
        </div>
      </section>
    </modal-content>
  </app-modal>
  }

  <ng-template #appPremiumTemplate>
    <div class="flex gap-default items-center">
      <img
        src="../../../assets/images/editorimages/premium-user-animation.webp"
        alt=""
        width="53"
        height="53"
      />
      <p class="mb-0 fw-medium">
        Unlock Premium tips to make the final difference.
      </p>
    </div>

    <div>
      <a href="/pricing" target="_blank" class="upgrade-pro">
        <app-icons name="premiumDiamondIcon" />
        <span>Upgrade</span>
      </a>
    </div>
  </ng-template>

  <ng-template #errorPopup>
    <div class="error-popup" *ngIf="activeError">
      <div class="error-popup-header">
        <div
          class="flex justify-between items-center py-1"
          style="padding-inline: 0.4rem"
        >
          <div class="flex items-center gap-default">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.1896 0H4.81039C2.15369 0 0 2.14903 0 4.8V19.2C0 21.851 2.15369 24 4.81039 24H19.1896C21.8463 24 24 21.851 24 19.2V4.8C24 2.14903 21.8463 0 19.1896 0Z"
                fill="#08BA9C"
              />
              <path
                d="M8.16262 9.21292C7.96887 9.67866 7.86195 10.189 7.86195 10.7231C7.86195 11.2571 7.96262 11.7389 8.14624 12.1934C8.14879 12.1996 8.15128 12.2071 8.15383 12.2133C8.75134 13.6688 10.1966 14.697 11.8873 14.697V17.6775C11.8495 17.6775 11.8131 17.6775 11.7753 17.6763C8.45322 17.6254 5.68833 15.3044 5.00529 12.2133C5.00403 12.2071 5.00277 12.1996 5.00151 12.1934C4.89836 11.719 4.84302 11.2273 4.84302 10.7231C4.84302 10.2188 4.90088 9.69977 5.01032 9.21292C5.70845 6.09832 8.5224 3.76855 11.8873 3.76855V6.74906C11.8495 6.74906 11.8131 6.74906 11.7753 6.75027C10.1413 6.79376 8.75134 7.79967 8.16262 9.21292Z"
                fill="white"
              />
              <path
                d="M18.7699 12.1972H18.7649C18.7649 12.2035 18.7686 12.2085 18.7699 12.2147V13.916C18.7699 16.0198 17.7988 18.0316 16.0893 19.2896C16.0315 19.3319 15.9723 19.3741 15.9132 19.415C14.7723 20.2011 13.3849 20.6619 11.8879 20.6619V17.6814C11.9257 17.6814 11.9622 17.6814 11.9999 17.6802C14.171 17.6218 15.9132 15.8645 15.9132 13.7074V12.1972H11.8879V9.2168H18.7649L18.7699 9.22174V12.1972Z"
                fill="white"
              />
            </svg>

            <h3
              class="error-popup-title fs-6 m-0"
              style="text-transform: capitalize"
            >
              <ng-container
                *ngIf="['modAcc', 'modClr'].includes(activeError.errorType)"
              >
                {{
                  activeError.errorType === "modAcc" ? "Accuracy" : "Clarity"
                }}
              </ng-container>
              <ng-container
                *ngIf="!['modAcc', 'modClr'].includes(activeError.errorType)"
              >
                {{ activeError.errorType }}
              </ng-container>
            </h3>
          </div>

          <button
            class="p-0 bg-transparent"
            style="margin-bottom: 4px"
            (click)="activeError = null"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.05029 5.0498L14.9498 14.9493"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M14.9497 5.0498L5.05021 14.9493"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
      </div>
      <div class="error-popup-body p-base text-14">
        <p
          class="mb-0"
          *ngIf="
            ['modAcc', 'modClr'].includes(activeError.errorType);
            else algoError
          "
          [innerHTML]="formatReplacementsArray(activeError.replacements[0])"
        ></p>

        <ng-template #algoError>
          <div class="mode-error-correction flex gap-sm">
            <span class="error-text">{{ activeError.wrong }}</span>
            <button
              class="corrected-text"
              [attr.data-target]="
                'err-' + activeError.ChkiD + '-' + activeError.offset
              "
              (click)="handlePseudoCorrectionOneWord($event)"
              [attr.data-correction]="activeError.replacements[0].value"
            >
              {{ activeError.replacements[0]?.value }}
            </button>
          </div>

          <p class="mt-3 mb-0">
            <em>{{ activeError.message }}</em>
          </p>
        </ng-template>
      </div>
      <div
        class="error-popup-footer p-base flex justify-between items-center mb-2"
        [ngClass]="{
          'pt-1': !['modAcc', 'modClr'].includes(activeError.errorType)
        }"
      >
        <ul
          class="flex gap-sm items-center list-unstyled m-0 p-0 text-15"
          *ngIf="
            ['modAcc', 'modClr'].includes(activeError.errorType);
            else dismissAlgo
          "
        >
          <li [attr.data-error]="'err-' + activeError.highlights[0].tread_id">
            <button
              class="correction-button accept-button"
              [attr.data-model]="activeError.errorType"
              [attr.data-target]="'err-' + activeError.highlights[0].tread_id"
              [attr.data-correction]="
                JSON.stringify(activeError.replacements[0])
              "
              [attr.data-correct]="activeError.correct"
              (click)="handlePseudoCorrection($event)"
            >
              Accept
            </button>
          </li>
          <li [attr.data-error]="'err-' + activeError.highlights[0].tread_id">
            <button
              class="flex items-center gap-sm btn-secondary text-center dismiss-button"
              style="height: 34px; width: 150px; text-align: center !important"
              [attr.data-target]="'err-' + activeError.highlights[0].tread_id"
              (click)="handlePseudoCorrection($event, 'Dismiss')"
            >
              Dismiss
            </button>
          </li>
        </ul>
        <ng-template #dismissAlgo>
          <ul class="flex gap-sm items-center list-unstyled m-0 p-0 text-15">
            <li
              [attr.data-error]="
                'err-' + activeError.ChkiD + '-' + activeError.offset
              "
            >
              <button
                class="flex items-center gap-sm btn-secondary text-center dismiss-button"
                style="
                  height: 34px;
                  width: 150px;
                  text-align: center !important;
                "
                [attr.data-target]="
                  'err-' + activeError.ChkiD + '-' + activeError.offset
                "
                (click)="handleDismiss($event)"
              >
                <span>Dismiss</span>
              </button>
            </li>
          </ul>
        </ng-template>
      </div>
    </div>
  </ng-template>
</main>
